import { render, staticRenderFns } from "./PaymentDetailModal.vue?vue&type=template&id=502c6872&"
import script from "./PaymentDetailModal.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('502c6872')) {
      api.createRecord('502c6872', component.options)
    } else {
      api.reload('502c6872', component.options)
    }
    module.hot.accept("./PaymentDetailModal.vue?vue&type=template&id=502c6872&", function () {
      api.rerender('502c6872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingPayment/PaymentDetailModal.vue"
export default component.exports